import { render, staticRenderFns } from "./download.vue?vue&type=template&id=4817ac10"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4817ac10')) {
      api.createRecord('4817ac10', component.options)
    } else {
      api.reload('4817ac10', component.options)
    }
    module.hot.accept("./download.vue?vue&type=template&id=4817ac10", function () {
      api.rerender('4817ac10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/log-service/force-upgrade/download.vue"
export default component.exports